import React from 'react';
import { Container } from '@hover/blueprint';
import Desktop from './Desktop';
import Tablet from './Tablet';
import Mobile from './Mobile';

const HoverReportsTable: React.FC = () => (
  <Container
    w="100%"
    centerContent
    maxW="1248px"
    px={{ base: 0, tablet: '56px', desktop: 500 }}
    mb={1000}
  >
    <Desktop />
    <Tablet />
    <Mobile />
  </Container>
);

export default HoverReportsTable;
